import { atomWithStorage } from "jotai/utils";
import { atom } from "jotai";

// Atom for storing user data and token
export const userAtom = atomWithStorage("userAtom", {
  isAuthenticated: false,
  user: null,
  accessToken: null,
  sessionExpired: false,
  is_paying: false,
});

// Atom for storing user onboarding data
export const onboardingAtom = atomWithStorage("onboardingAtom", {
  book_title: "",
  author_name: "",
  author_bio: "",
  book_genre: [],
  logline: "",
  keywords: [],
  book_user_info_id: null,
});

export const currentBookAtom = atom({
  book_title: "",
  author_name: "",
  author_bio: "",
  book_genre: [],
  logline: "",
  keywords: [],
  book_user_info_id: null,
});
